import Keycloak from "keycloak-js";
import { env } from "@configs/Env";

/**
 * Keycloak 싱글톤.
 *
 * StrictMode/HMR 로 모듈이 여러 번 평가되어도 단일 인스턴스를 재사용한다.
 * `keycloak.init()`은 인스턴스당 한 번만 호출할 수 있으므로 반드시 싱글톤이어야 한다.
 */
let keycloakInstance: Keycloak | null = null;

function getKeycloak(): Keycloak {
  keycloakInstance ??= new Keycloak({
    url: env.keycloakUrl,
    realm: env.keycloakRealm,
    clientId: env.keycloakClientId
  });
  return keycloakInstance;
}

export const keycloak = getKeycloak();
